import React from "react";
import { FiEdit2, FiExternalLink, FiEye, FiImage, FiMap } from "react-icons/fi";

import { toAbsolutePublicUrl } from "../../../../services/mediaLibraryServices";

import AdminButton from "../../_shared/ui/AdminButton";
import AdminDrawer from "../../_shared/ui/AdminDrawer";
import ProjetStatusBadge from "./ProjetStatusBadge";

import { formatDateTime } from "../utils/projetsAdminUtils";

export default function ProjetsPreviewDrawer({
  open,
  item,
  onClose,
  onEditFromPreview,
}) {
  const imageUrl = item?.image_projet_url
    ? toAbsolutePublicUrl(item.image_projet_url)
    : "";

  return (
    <AdminDrawer
      open={open}
      onClose={onClose}
      title="Aperçu du projet"
      subtitle="Visualisez rapidement le rendu du projet."
      icon={FiEye}
      size="xl"
      footer={
        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <AdminButton variant="secondary" onClick={onClose}>
            Fermer
          </AdminButton>

          {item?.id ? (
            <AdminButton
              icon={FiEdit2}
              variant="primary"
              onClick={onEditFromPreview}
            >
              Modifier ce projet
            </AdminButton>
          ) : null}
        </div>
      }
    >
      {!item ? (
        <p className="text-sm text-slate-500 dark:text-slate-400">
          Projet introuvable.
        </p>
      ) : (
        <article className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={item.titre}
              className="max-h-[420px] w-full object-cover"
            />
          ) : (
            <div className="flex min-h-[240px] flex-col items-center justify-center bg-slate-100 text-slate-400 dark:bg-slate-800 dark:text-slate-500">
              <FiImage className="text-5xl" />
              <p className="mt-3 text-sm font-bold">Aucune image associée</p>
            </div>
          )}

          <div className="p-5 sm:p-7">
            <div className="flex flex-wrap items-center gap-3">
              <ProjetStatusBadge active={!!item.is_active} />

              <span className="inline-flex items-center gap-1.5 rounded-full border border-orange-200 bg-orange-50 px-2.5 py-1 text-xs font-bold text-orange-700 dark:border-orange-500/20 dark:bg-orange-500/10 dark:text-orange-300">
                <FiMap />
                Projet
              </span>

              <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-slate-500 dark:bg-slate-800 dark:text-slate-400">
                {formatDateTime(item.created_at)}
              </span>
            </div>

            <h1 className="mt-5 text-3xl font-bold leading-tight text-slate-950 dark:text-white">
              {item.titre}
            </h1>

            {item.page_detail_url ? (
              <p className="mt-5">
                <a
                  href={item.page_detail_url}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 rounded-2xl bg-sky-600 px-4 py-3 text-sm font-bold text-white transition hover:bg-sky-700"
                >
                  <FiExternalLink />
                  Voir la page détail
                </a>
              </p>
            ) : null}

            {item.description ? (
              <div
                className="prose prose-slate mt-6 max-w-none dark:prose-invert prose-headings:font-bold prose-a:text-sky-600"
                dangerouslySetInnerHTML={{
                  __html: item.description,
                }}
              />
            ) : (
              <p className="mt-6 text-sm text-slate-500 dark:text-slate-400">
                Aucune description renseignée.
              </p>
            )}
          </div>
        </article>
      )}
    </AdminDrawer>
  );
}